import axios from '@axios'

const PREFIX = '/monitoramento-360'

export default {
  getPaginado(page, pageSize, filtros, filtroString, idFiltroCustom) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}&multiFiltro=${filtroString}&idFiltroCustom=${idFiltroCustom ?? 0}`, filtros)
  },

  baixarEmExcel(tipo, filtros) {
    return axios.post(`${PREFIX}/baixa-excel`, filtros)
  },

  deletarExcel(url, nomeArquivo) {
    axios.post(`${PREFIX}/deletar-excel?url=${url}&nomeArquivo=${nomeArquivo}`)
  },
  getPendencias(id) {
    return axios.get(`${PREFIX}/${id}/pendencias`)
  },

  baixarPendenciasEmExcel(id) {
    return axios.post(`${PREFIX}/${id}/pendencias/baixa-excel`)
  },

  baixarDocumentos(id, docs = null) {
    const query = docs && docs.length > 0 ? `?docs=${docs.join(',')}` : ''
    return axios.post(`${PREFIX}/${id}/baixar${query}`)
  },

  visualizarDocumentos(id, docs = null) {
    const query = docs && docs.length > 0 ? `?docs=${docs.join(',')}` : ''
    return axios.post(`${PREFIX}/${id}/visualizar${query}`)
  },

  enviarEmail(id, payload) {
    return axios.post(`${PREFIX}/${id}/enviar-email`, payload)
  },

  getDocWhatsapp(id, docs = null) {
    const query = docs && docs.length > 0 ? `?docs=${docs.join(',')}` : ''
    return axios.post(`${PREFIX}/${id}/whatsapp${query}`)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  salvarObservacao(dto) {
    return axios.post(`${PREFIX}/observacao/salvar`, dto)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },
}
